export default __webpack_public_path__ + "static/media/IMG_4989-min.710c8d66.JPG";